import * as clientActionTypes from "../../Constants/clientActionTypes";
import API from "./../../Constants/API";
import * as clientsServices from "../../services/clients/index";
import moment from 'moment';

export function getClientIntegartionType(firmId) {
    return async dispatch => {
        const integrationType = await clientsServices.req.getIntegartionTypes(API.getIntegrationType, firmId);
        console.log(integrationType);
        return dispatch({
            type: clientActionTypes.GET_INTEGRATION_TYPE,             
            payload: { integrationType }
        });
    };
}
export function getClientLookupData(firmId) {
    return async dispatch => {
        const clientLookUpData = await clientsServices.req.getClientLinkedData(API.getClientLookUpDetails, firmId);
        console.log(clientLookUpData);
        return dispatch({
            type: clientActionTypes.GET_CLIENT_LINKING_DATA,
            payload: { clientLookUpData }
        });
    };
}

export function getTaxTaskToBeLinkedData(firmId) {
    return async dispatch => {
            const taxNotLinkedLookUpData = await clientsServices.req.getTaxNotLinkedData(API.getTaxNotLinkedData, firmId);
            const mappedTaxToBeLinkedData = taxNotLinkedLookUpData.filter(formatDateTaxNotLinked);
        return dispatch({
            type: clientActionTypes.GET_TAX_NOT_LINKED_DATA,
            payload: { mappedTaxToBeLinkedData }
        });
    };
}

export function getMappedClientData(firmId) {
    return async dispatch => {
        const isClientMapped = await clientsServices.req.getClientMappedData(API.getMappeClientDetails, firmId);
        console.log(isClientMapped);
        return dispatch({
            type: clientActionTypes.GET_CLIENT_MAPPED_DATA,
            payload: { isClientMapped }
        });
    };
}

export function getFirmDocumentSync(firmId) {
    return async dispatch => {
        const documentSyncLookUpData = await clientsServices.req.getFirmDocumentSync(API.getFirmDocumentSync, firmId);
        console.log(documentSyncLookUpData);
        return dispatch({
            type: clientActionTypes.GET_FIRM_DOCUMENT_SYNC,
            payload: { documentSyncLookUpData }
        });
    };
}

function formatDateTaxNotLinked(item){
    item.dueDate= moment(item.dueDate).format('MM/DD/YY');
    item.periodEndDate = moment(item.periodEndDate).format('MM/DD/YY');
    return item;
}